export const getWindow = () => (typeof window !== 'undefined' ? window : undefined);
